<cwc-alert
  [variant]="type"
  [message]="message"
  [ctaMessage]="ctaMessage"
  [duration]="lifeSpan"
  [keepOpen]="!autoClose"
  (cwcAlertClick)="click()"
></cwc-alert>
